import { Resource } from 'i18next';

// Translations
import ruRU from './ruRU.json';
import enUS from './enUS.json';

export const locales: Resource = {
  ruRU,
  enUS
};
